export const API_V1_AUTH = "/api/v1/auth";
export const API_V1_AUTH_LOGIN = API_V1_AUTH + "/login";
export const API_V1_AUTH_LOGIN_RENEW = API_V1_AUTH + "/login/renew";
export const API_V1_AUTH_LOGOUT = API_V1_AUTH + "/logout";

export const API_V1_AGENT = "/api/v1/agent";
export const API_V1_AGENT_BREAK_START = API_V1_AGENT + "/break/start";
export const API_V1_AGENT_DASHBOARD_KPIS = API_V1_AGENT + "/dashboard/kpis";
export const API_V1_AGENT_STATUS = API_V1_AGENT + "/status";

export const API_V1_CHATS = "/api/v1/chats";

export const API_V1_CREDIT_REQUESTS = "/api/v1/credits";
export const API_V1_CREDIT_ATTACHMENTS = "/api/v1/credit-attachments";
export const API_V1_CREDIT_ATTACHMENT_TYPES = "/api/v1/credit-attachment-types";
export const API_V1_CREDIT_PAYMENTS = "/api/v1/credit-payments";
export const API_V1_CREDIT_LINKS = "/api/v1/credit-links";

export const API_V1_BANK_CREDIT_REQUESTS = "/api/v1/bank-credits";

export const API_V1_CARD = "/api/v1/cards";
export const API_V1_CARD_LINKS = "/api/v1/card-links";

export const API_V1_ME = "/api/v1/me";
export const API_V1_ME_LANGUAGE_CHANGE = API_V1_ME + "/language-change";

export const API_V1_PROFILES = "/api/v1/profiles";

export const API_V1_USERS = "/api/v1/users";
export const API_V1_USER_DATA = "/api/v1/user-data";
export const API_V1_USER_COMMENTS = "/api/v1/user-comments";
export const API_V1_USER_RECOMMENDATIONS = "/api/v1/user-recommendations";
export const API_V1_USER_ATTACHMENTS = "/api/v1/user-attachments";

export const API_V1_CONTROL = "/api/v1/control";
export const API_V1_MOTIVATIONAL_MESSAGES = "/api/v1/motivational-messages";

export const API_V1_TODO = "/api/v1/todo";
export const API_V1_TUTTI = "/api/v1/tutti";
export const API_V1_ADMIN_TARGETS = "/api/v1/admin/targets";
export const API_V1_ADMIN_TARGETS_AGENTS = API_V1_ADMIN_TARGETS + "/agents";
export const API_V1_ADMIN_TARGETS_OPTIONS = "/api/v1/admin/targets/options";
export const API_V1_ADMIN_DASHBOARD_KPIS = "/api/v1/admin/dashboard/kpis";
export const API_V1_ADMIN_DASHBOARD_BANK_STATUS = "/api/v1/admin/dashboard/bank-status";
export const API_V1_ADMIN_DASHBOARD_CONVERSION_HEALTH = "/api/v1/admin/dashboard/conversion-health";
export const API_V1_ADMIN_DASHBOARD_DELAYED_PROCESSING_ALARM_COUNT =
  "/api/v1/admin/dashboard/delayed-processing-alarm/count";
export const API_V1_ADMIN_DASHBOARD_DELAYED_PROCESSING_ALARM_INFO =
  "/api/v1/admin/dashboard/delayed-processing-alarm/info";
export const API_V1_ADMIN_DASHBOARD_MONTHLY_PROGRESS = "/api/v1/admin/dashboard/monthly-progress";
export const API_V1_ADMIN_DASHBOARD_YEARLY_PROGRESS = "/api/v1/admin/dashboard/yearly-progress";
export const API_V1_ADMIN_DASHBOARD_AGENTS = "/api/v1/admin/dashboard/agents";
export const API_V1_ADMINISTRATOR_DASHBOARD_KPIS = "/api/v1/administrator/dashboard/kpis";
export const API_V1_ADMINISTRATOR_DASHBOARD_BANK_STATUS =
  "/api/v1/administrator/dashboard/bank-status";
export const API_V1_ADMINISTRATOR_DASHBOARD_CONVERSION_HEALTH =
  "/api/v1/administrator/dashboard/conversion-health";
export const API_V1_ADMINISTRATOR_DASHBOARD_DELAYED_PROCESSING_ALARM_COUNT =
  "/api/v1/administrator/dashboard/delayed-processing-alarm/count";
export const API_V1_ADMINISTRATOR_DASHBOARD_DELAYED_PROCESSING_ALARM_INFO =
  "/api/v1/administrator/dashboard/delayed-processing-alarm/info";
export const API_V1_ADMINISTRATOR_DASHBOARD_MONTHLY_PROGRESS =
  "/api/v1/administrator/dashboard/monthly-progress";
export const API_V1_ADMINISTRATOR_DASHBOARD_YEARLY_PROGRESS =
  "/api/v1/administrator/dashboard/yearly-progress";
export const API_V1_ADMINISTRATOR_DASHBOARD_AGENTS =
  "/api/v1/administrator/dashboard/agents";
export const API_V1_TEAM_LEAD_DASHBOARD_KPIS = "/api/v1/team-lead/dashboard/kpis";
export const API_V1_TEAM_LEAD_DASHBOARD_BANK_STATUS = "/api/v1/team-lead/dashboard/bank-status";
export const API_V1_TEAM_LEAD_DASHBOARD_CONVERSION_HEALTH =
  "/api/v1/team-lead/dashboard/conversion-health";
export const API_V1_TEAM_LEAD_DASHBOARD_DELAYED_PROCESSING_ALARM_COUNT =
  "/api/v1/team-lead/dashboard/delayed-processing-alarm/count";
export const API_V1_TEAM_LEAD_DASHBOARD_DELAYED_PROCESSING_ALARM_INFO =
  "/api/v1/team-lead/dashboard/delayed-processing-alarm/info";
export const API_V1_TEAM_LEAD_DASHBOARD_MONTHLY_PROGRESS =
  "/api/v1/team-lead/dashboard/monthly-progress";
export const API_V1_TEAM_LEAD_DASHBOARD_AGENTS = "/api/v1/team-lead/dashboard/agents";
export const API_V1_TEAM_LEAD_DASHBOARD_DAILY_STATE = "/api/v1/team-lead/dashboard/daily-state";
export const API_V1_TEAM_LEAD_DASHBOARD_DAILY_KPIS = "/api/v1/team-lead/dashboard/daily-kpis";
export const API_V1_TEAM_LEAD_DASHBOARD_DAILY_STATE_ITEMS =
  "/api/v1/team-lead/dashboard/daily-state/items";
export const API_V1_TEAM_LEAD_DASHBOARD_CALENDAR = "/api/v1/team-lead/dashboard/calendar";
export const API_V1_AGENT_DASHBOARD_CALENDAR = "/api/v1/agent/dashboard/calendar";

export const API_V1_KPI = "/api/v1/kpi";
export const API_V1_KPI_METRICS = API_V1_KPI + "/metrics";
export const API_V1_KPI_AGENTS = API_V1_KPI + "/agents";

export const API_V1_ABSENCE = "/api/v1/absence";
export const API_V1_HOLIDAY = "/api/v1/holiday";

export const API_V1_PRELIMINARY_CREDITS = "/api/v1/preliminary-credits";

export const API_V1_QUICK_CHECK = "/api/v1/quick-check";

export const API_V1_BANK_SPECIFIC = "/api/v1/bank-specific";
export const API_V1_BANK_COMMENTS = "/api/v1/bank-comments";
export const API_V1_BANK_CREDIT_NOTES = "/api/v1/bank-credit-note";
export const API_V1_BANK_ATTACHMENTS = "/api/v1/bank-attachments";
export const API_V1_XML = "/api/v1/xml";

export const API_V1_CONTRACT = "/api/v1/contract";
export const API_V1_CONTRACT_ATTACHMENTS = "/api/v1/contract-attachments";
export const API_V1_CONTRACT_DOCUMENTS = "/api/v1/contract-documents";
export const API_V1_CONTRACT_PAYMENTS = "/api/v1/contract-payments";
export const API_V1_CONTRACT_ADJUSTMENTS = "/api/v1/contract-adjustments";

export const EXCEPTION_IDENTITY_NOT_FOUND = "IDENTITY_NOT_FOUND";

export const PROFILE_AGENT_ID = 2;
export const PROFILE_ADMIN_ID = 1;
